import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 5
const slug = 'high-rise-and-commercial-formwork-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `High-Rise & Commercial Formwork Sydney | ${BUSINESS_NAME}`,
        description: "Scalable solutions for towers, apartments, and commercial builds.",
        keywords: "high-rise formwork sydney, commercial formwork, tower formwork, apartment formwork, large-scale formwork, concrete formwork, structural support, commercial construction, residential construction, custom formwork design, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'High-Rise & Commercial Formwork Sydney',
    description: 'Scalable solutions for towers, apartments, and commercial builds.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
